// In some places we have links inside links but this is not valid HTML so
// browser will modify the DOM silently.
// This allows us to still use links in links, by making some of them "fake" links.
stimulusApp.register(
  "link",
  class extends Stimulus.Controller {
    static values = {
      href: String,
      turboFrame: String,
      target: { type: String, default: "_blank" },
    }

    connect() {
      this.element.style.cursor = "pointer"
      this.element.addEventListener("click", this.clickHandler)
    }

    disconnect() {
      this.element.removeEventListener("click", this.clickHandler)
    }

    clickHandler = (event) => {
      if (event.defaultPrevented) {
        // Allow children to prevent the link by preventing default, just like for regular a links.
        return
      }

      // Let child <a> tags handle their own navigation
      // And be sure that link tag inside the controller itself
      if (
        event.target.closest("a")?.closest("[data-controller='link']") ===
        this.element
      ) {
        event.stopPropagation()
        return
      }

      event.preventDefault()
      if (this.hrefValue) {
        if (this.turboFrameValue) {
          Turbo.visit(this.hrefValue, { frame: this.turboFrameValue })
        } else {
          window.open(this.hrefValue, this.targetValue, "noopener")
        }
      }
    }
  },
)
